import React, { useState, useContext } from 'react'

import { View } from 'styles/reactnative'
import CModalHeader from '../Modal/CModalHeader'
import { useWSize } from 'utils/ExpensiveFunction'
import TransferFromTo from './TransferFromTo'
import TransferCoin from './TransferCoin'
import TransferAmount from './TransferAmount'
import TransferFooter from './TransferFooter'
import { useBalance } from 'app/hooks/user/mybalance'
import { ThemeContext } from 'theme/ThemeProvider'

const TransferModal = ({ setShowModal }) => {
	const { drawerBgColor } = useContext(ThemeContext).theme.COLORS

	const [transferFrom, setTransferFrom] = useState('spotwallet')
	const [transferTo, setTransferTo] = useState('futurewallet')
	const [amount, setAmount] = useState('')
	// const { data: tradeStore } = useTradeStore()
	const coinType = 'USDT'

	let type = 0
	if (transferFrom === 'futurewallet') {
		type = 1
	}

	const { data: balance } = useBalance(coinType, type)

	return (
		<View
			style={{
				width: useWSize(80),
				height: 430,
				borderRadius: 5,
				backgroundColor: drawerBgColor,
				alignItems: 'flex-start',
				justifyContent: 'flex-start',
			}}>
			<CModalHeader
				title={'transfer'}
				closeModal={() => setShowModal(false)}
			/>
			<View style={{ width: '100%', paddingInline: 20 }}>
				<TransferFromTo
					transferFrom={transferFrom}
					setTransferFrom={setTransferFrom}
					transferTo={transferTo}
					setTransferTo={setTransferTo}
				/>
				<TransferCoin />
				<TransferAmount
					balance={balance?.balance}
					amount={amount}
					setAmount={setAmount}
				/>
				<TransferFooter
					transferFrom={transferFrom === 'spotwallet' ? 0 : 1}
					transferTo={transferTo === 'spotwallet' ? 0 : 1}
					amount={amount}
					coinType={coinType}
					balance={balance?.balance}
				/>
			</View>
		</View>
	)
}

export default React.memo(TransferModal)
